module.exports = __webpack_public_path__ + "img/return.fbdd53dd.png";